export var ProductCategory;
(function (ProductCategory) {
    ProductCategory["physicalSale"] = "physicalSale";
    ProductCategory["digitalSale"] = "digitalSale";
    ProductCategory["sale"] = "sale";
    ProductCategory["freebie"] = "freebie";
})(ProductCategory || (ProductCategory = {}));
